import { cn } from '@/lib/utils'
import useSWR from 'swr'
import { formatUSD } from '@/lib/format-utils'

export const ColumnCost = {
  id: 'cost',
  header: 'Cost',
  cell: ({ row }) => {
    const data = row.original
    return <div>{formatUSD(data.cost || 0, 0, 0)}</div>
  },
}

export const ColumnIAA = {
  id: 'iaa',
  header: 'IAA',
  cell: ({ row }) => {
    const data = row.original
    return (
      <div>
        {formatUSD(data.revenues?.total - data.revenues?.apple || 0, 0, 0)}
      </div>
    )
  },
}

export const ColumnIAP = {
  id: 'iap',
  header: (
    <div className="flex items-center gap-2">
      <div className="w-24 text-right">Cost</div>
      <div className="w-24 text-right">Revenue</div>
      <div className="w-24 text-right">IAP</div>
      <div className="w-24 text-right">IAA</div>
      <div className="w-24 text-right">Profit</div>
      <div className="w-24 text-right"></div>
      <div className="w-24 text-right">Revenue(r)</div>
      <div className="w-24 text-right">IAP(r)</div>
      <div className="w-24 text-right">Profit(r)</div>
    </div>
  ),
  cell: ({ row }) => {
    return <RenderIAP row={row} duration={3} />
  },
}

const RenderIAP = ({ row }) => {
  const rowData = row.original
  const country = rowData.country

  const params = {
    subAt: rowData.date,
    country,
  }
  const { data: iapData } = useSWR([`/revenues/reg/iap`, params])

  if (!iapData) return <div>-</div>

  const revenueTotal = rowData.revenues?.total
  const iap = rowData.revenues?.apple
  const cost = rowData.cost
  const iapr = iapData.total
  const iaa = revenueTotal - iap

  const profit = revenueTotal - cost
  const profitr = iapr + iaa - cost

  return (
    <div className={cn('flex items-center gap-2')}>
      <div className="w-24 text-nowrap text-right">{formatUSD(cost, 0, 0)}</div>
      <div className="w-24 text-nowrap text-right">
        {formatUSD(revenueTotal, 0, 0)}
      </div>
      <div className="w-24 text-nowrap text-right">{formatUSD(iap, 0, 0)}</div>
      <div className="w-24 text-nowrap text-right">{formatUSD(iaa, 0, 0)}</div>
      <div
        className={cn(
          'w-24 text-nowrap text-right',
          profit > 0 && 'text-green-500',
          profit < 0 && 'text-red-500',
        )}
      >
        {formatUSD(profit, 0, 0)}
      </div>
      <div className="w-24 text-nowrap text-right"></div>
      <div className="w-24 text-nowrap text-right">
        {formatUSD(iapr + iaa, 0, 0)}
      </div>
      <div className="w-24 text-nowrap text-right">{formatUSD(iapr, 0, 0)}</div>
      <div
        className={cn(
          'w-24 text-nowrap text-right',
          profitr > 0 && 'text-green-500',
          profitr < 0 && 'text-red-500',
        )}
      >
        {formatUSD(profitr, 0, 0)}
      </div>
    </div>
  )
}
